export default __webpack_public_path__ + "static/assets/7808d3b49fdf33cb82e053f00a27ba33.png";